import { useEffect, useState } from 'react'
import Modal from '../../../../atom/modal';
import DevicesIcon from "@mui/icons-material/Devices"
import ComponentMap from '../../../../atom/componentmap';
import ThemedButton from '../../../../atom/ThemedButton/themedButton';
import { addDevice, getDeviceMake, getDeviceModel, getUsers } from '../../../../services/api';
import { addAKeyValueFromRefListItems, addChildrensToMapData } from '../../../../services/utilities';
import Notification from "../../../../atom/Notification";
import Devices from '../devices';
import { useTranslation } from 'react-i18next';
import { log } from 'console';



function AddSipDevice(props: any) {
    const { t } = useTranslation()

    const { setModal, childStatus, setchildStatus, getUserDetails, activeItem = {}, devices, deviceChange, setDeviceChange } = props;
    const [status, setStatus] = useState<any>('false')
    const [buttonLoader, setButtonloader] = useState<any>(false)

    // const handleDeviceMakeChange = (make: string, model = '') => {
    //     handleDropdown({ make: make }, 'model', model)
    // }

    // const handleModelChange = (value: string) => {
    //     console.log("value", value)
    //     const result: any = data[8]?.childrens?.find((node: any) => {
    //         return node.model === value
    //     })
    //     setData(addChildrensToMapData([...data], result.line, 'line_no'));
    // }
    const [data, setData] = useState([
        // {
        //     title: 'uuid',
        //     name: 'user_id',
        //     value: activeItem?.uuid,
        //     hidden: true
        // },
        {
            title: t("Control.Devices.Name"),
            name: "name",
            layout: 3,
            value: "",
            required: true,
            errormessage: t("Control.Devices.NameIsRequired"),
        },
        {
            name: 'type',
            title: t("Control.Devices.Type"),
            value: 'sip',
            hidden: true
        },

        {
            title: t("Control.Devices.Username"),
            name: "login",
            layout: 3,
            value: "",
            required: true,
            errormessage: t("Control.Devices.UserNameIsRequired"),
        },
        {
            name: "user_id.uuid",
            title: t("Control.Devices.AssignedTo"),
            type: "dropdown",
            displayProps: { "label": "label", "value": "uuid" },
            childrens: [

            ],
            layout: 3,
            value: "none",
            required: true,
            errormessage: t("Control.Devices.PleaseSelectaPerson"),
        },
        {
            title: t("Control.Devices.NotifyOnUnregister"),
            name: "notify_on_unregister",
            layout: 6,
            type: "checkbox",
            value: false,
        },
        // {
        //     title: t("Control.Devices.AutoProvision"),
        //     name: "auto_provsion",
        //     reference: {
        //         "items": ["mac_id", "make", "model", "line_no"],
        //         "action": "hidden",
        //         "condition": {
        //             "operator": "!="
        //         }
        //     },
        //     layout: 6,
        //     type: "checkbox",
        //     value: false,
        // },
        // {
        //     title: t("Control.Devices.MacAddress"),
        //     name: "mac_id",
        //     layout: 3,
        //     value: "",
        //     hidden: true,
        //     required: true,
        //     errormessage: t("Control.Devices.MacAddressIsRequired"),
        // },
        // {
        //     title: t("Control.Devices.DeviceMake"),
        //     name: "make",
        //     type: "dropdown",
        //     displayProps: { "label": "make", "value": "make" },
        //     childrens: [],
        //     layout: 3,
        //     value: "",
        //     Callback: handleDeviceMakeChange,
        //     hidden: true,
        //     required: false,
        //     errormessage: t("Control.Devices.PleaseSelectADeviceMake"),
        // },
        // {
        //     title: t("Control.Devices.DeviceModel"),
        //     name: "model",
        //     type: "dropdown",
        //     displayProps: { "label": "model", "value": "model" },
        //     childrens: [],
        //     layout: 3,
        //     value: "",
        //     Callback: handleModelChange,
        //     required: false,
        //     hidden: true,
        //     errormessage: t("Control.Devices.PleaseSelectADeviceModal"),
        // },
        // {
        //     title: t("Control.Devices.Line"),
        //     name: "line_no",
        //     type: "dropdown",
        //     childrens: [],
        //     layout: 3,
        //     value: "",
        //     required: false,
        //     hidden: true,
        //     errormessage: t("Control.Devices.PleaseSelectALine"),
        // }
    ])

    const onSave = (result: any) => {

        setButtonloader(true)
        result['user_id'] = result['user_id.uuid']
        delete result['user_id.uuid'];
        addDevice(result).then((result: any) => {
            if (result?.data?.parameter || result?.data?.reason) {
                let msg = result?.data?.reason
                Notification(t("Control.Features.Failed"), msg?.charAt(0).toUpperCase() + msg?.slice(1), "danger")
                setButtonloader(false)
                setModal("")
                setStatus('true')

            } else {
                Notification("Success", t("Control.Devices.DeviceAddedSuccessfully"), "success");
                setButtonloader(false)
                setModal("")
                setStatus('true')
                // setDeviceChange(!deviceChange)
            }
            setchildStatus(!childStatus)

            if (Object.keys(activeItem).length !== 0 && activeItem?.first_name) {
                getUserDetails()
                setButtonloader(false)
                setModal("")
                setStatus('true')
            }

        }).catch((error: any) => {
            Notification("Error", "Error", "danger");
            setchildStatus(!childStatus)
            setButtonloader(false)
            setModal("")
            setStatus('true')
        })
    }

    const onCancel = () => {
        setModal("")

    }

    // const handleDropdown = (payload: any, item: string, model = '') => {
    //     console.log("typee", payload, 'model', model)

    //     getDeviceModel(payload).then((result: any) => {
    //         setData(addChildrensToMapData([...data], result, item));
    //         if (model) {
    //             const res: any = data[9].childrens?.find((node: any) => {
    //                 return node.model === model
    //             })
    //             setData(addChildrensToMapData([...data], res.line, 'line_no'));
    //         }
    //     })
    // }


    // const handleDeviceMake = () => {
    //     getDeviceMake({}).then((result: any) => {
    //         setData(addChildrensToMapData([...data], result, 'make'));
    //     })
    // }
    const getAssignedValues = () => {
        getUsers({}).then((result: any) => {
            let UpdatedResult = addAKeyValueFromRefListItems(result, "label", ["first_name", "last_name"])
            UpdatedResult.unshift({ label: 'None', uuid: 'none' })
            setData(addChildrensToMapData([...data], UpdatedResult, "user_id.uuid"));
        })
    }

    useEffect(() => {
        getAssignedValues();

    }, [])

    return (
        <div>
            <Modal
                icon={<DevicesIcon />}
                title={t("DashBoard.AddSipDevice")}
                closeEvent={() => {
                    setModal("")
                }}
            >
                <div className="w-[700px]">
                    <ComponentMap data={data} setData={setData} />
                    <div className="text-right ">
                        <ThemedButton
                            children={t("Cancel")}
                            icon="cancel"
                            theme="secondary"
                            click={onCancel}
                        />
                        <ThemedButton
                            children={t("Save")}
                            icon="update"
                            theme="primary"
                            valiData={data}
                            change={setData}
                            loading={buttonLoader}
                            click={onSave}
                        />
                    </div>
                </div>
            </Modal>
            {status === 'true' ?
                <Devices status={status} />
                : null
            }

        </div>
    )
}


export default AddSipDevice